$(function () {
	if ("ontouchstart" in document.documentElement) {
		$('.jq_dropdown').click(function() {
			$(this).toggleClass('on');
		});
	}
});